import { red, green } from "@material-ui/core/colors";

const snack_types = {
  SUCCESS: green[500],
  ERROR: red[700]
};

export default snack_types;
